import React, { Component } from "react";
import {
    MenuItem,
    InputLabel,
    Select,
    TableContainer,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
} from "@material-ui/core";
import { Button } from "reactstrap";
import ReactToPrint from "react-to-print";

class CompareTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comUser: [],
        };
    }

    render() {
        const { user, userDetails, reportTitles } = this.props;
        return (
            <>
                <InputLabel>Select Users to Compare</InputLabel>
                <Select
                    multiple={true}
                    value={this.state.comUser}
                    onChange={(event) => {
                        let comUser = this.state.comUser;
                        comUser = event.target.value;
                        this.setState({
                            comUser,
                        });
                        this.props.setUser(comUser);
                    }}
                >
                    {user &&
                        user.map((e, i) => {
                            return (
                                <MenuItem key={i} value={e.uid}>
                                    {e.name}
                                </MenuItem>
                            );
                        })}
                </Select>
                <ReactToPrint
                    trigger={() => (
                        <Button
                            style={{
                                fontSize: "20px",
                                marginLeft: "95px",
                                marginTop: "7px",
                            }}
                            color="primary"
                            variant="contained"
                        >
                            Print
                        </Button>
                    )}
                    content={() => this.componentRef}
                />
                <div ref={(el) => (this.componentRef = el)}>
                    <TableContainer>
                        <Table
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell>Report Type</TableCell>
                                    {userDetails &&
                                        userDetails.map((data, i) => {
                                            return (
                                                <TableCell key={i}>
                                                    {data.names}
                                                </TableCell>
                                            );
                                        })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportTitles &&
                                    Object.keys(reportTitles).map(
                                        (report_key) => {
                                            return (
                                                <TableRow key={report_key}>
                                                    <TableCell align="left">
                                                        {
                                                            reportTitles[
                                                                report_key
                                                            ]
                                                        }
                                                    </TableCell>
                                                    {userDetails &&
                                                        userDetails.map(
                                                            (data, i) => {
                                                                return (
                                                                    <TableCell
                                                                        key={i}
                                                                        component="th"
                                                                        scope="row"
                                                                    >
                                                                        {data[
                                                                            report_key
                                                                        ]
                                                                            ? data[
                                                                                  report_key
                                                                              ]
                                                                            : 0}
                                                                    </TableCell>
                                                                );
                                                            }
                                                        )}
                                                </TableRow>
                                            );
                                        }
                                    )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </>
        );
    }
}
export default CompareTable;
